import { DropdownItem } from "../../components/select/Select";
import {
  AdministrateurBien,
  FonctionPoste,
  Profil,
  Site,
  Utilisateur,
  UtilisateurDetailAdbProfilSites,
  UtilisateurRoleEnum,
} from "../../services/Api/swagger";
import { UtilisateurFormData } from "./UtilisateurAdbForm";
import { UtilisateurBesseFormData } from "./UtilisateurBesseForm";

/**
 * Construit les options pour la liste des fonctions d'un utilisateur ADB
 * (conversion pour être conforme au format attendu par le composant Select)
 * Valeur par défaut pour éviter erreur TypeScript
 */
export const construireListFonctionsOptions = (
  fonctionsPostes: FonctionPoste[]
): DropdownItem[] =>
  fonctionsPostes.map(
    (item: FonctionPoste): DropdownItem => ({
      key: item.identifiant || 0,
      text: item.libelle || "",
      value: item.identifiant?.toString() || "",
    })
  );

export const construireListProfils = (profils: Profil[]): DropdownItem[] =>
  profils.map(
    (item: Profil): DropdownItem => ({
      key: item.identifiant || 0,
      text: item.nom || "",
      value: item.identifiant?.toString() || "",
    })
  );

export const construireListRegroupements = (
  regroupements: AdministrateurBien[]
): DropdownItem[] =>
  regroupements.map(
    (item: AdministrateurBien): DropdownItem => ({
      key: item.identifiant || 0,
      text: item.nom || "",
      value: item.identifiant?.toString() || "",
    })
  );

export const construireListAdbDetail = (
  detail: Site[] | undefined,
  refAdb: number
): DropdownItem[] | undefined => {
  return (
    detail &&
    detail.map(
      (item: Site): DropdownItem => ({
        key: item.numero ? item.numero + refAdb : 0,
        text: item.nom || "",
        value: item.numero?.toString() || "",
      })
    )
  );
};
export const construireListProfilsBesse = (profils: Profil[]): DropdownItem[] =>
  profils.map(
    (item: Profil): DropdownItem => ({
      key: item.identifiant || 0,
      text: item.nom || "",
      value: item.identifiant?.toString() || "",
    })
  );
/**
 * Transforme les données saisies dans le formulaire Utilisateur dans le format attendu par l'API
 * @param values
 */
export const transformUtilisateurDataToModel = (
  values: UtilisateurFormData
): Utilisateur => {
  const construireListAdb: any[] | undefined =
    values.adbs &&
    values.adbs.map((list) => {
      const sitesValues =
        // @ts-ignore TODO verify types ?
        list && list.sites && list.sites.map((site) => site.value);
      return {
        ...list,
        refAdb: Number(list.refAdb),
        codeApplication: "AGREMENT",
        profil: Number(list.profil),
        sites: sitesValues,
      };
    });
  const utilisateur: Utilisateur = {
    nom: values.nom,
    prenom: values.prenom,
    mail: values.mail,
    role: UtilisateurRoleEnum["ADB"],
    fonction: Number(values.fonction),
    detailAdbProfilSites: construireListAdb,
    motDePasse: values.motDePasse,
  };
  return utilisateur;
};

/**
 * Transforme les données saisies dans le formulaire utilisateur BESSE dans le format attendu par l'API
 * @param values
 */
export const transformUtilisateurBesseDataToModel = (
  values: UtilisateurBesseFormData
): Utilisateur => {
  const utilisateur: Utilisateur = {
    nom: values.nom,
    prenom: values.prenom,
    mail: values.mail,
    role: UtilisateurRoleEnum["BESSE"],
    profilBesse: Number(values.profilBesse),
    motDePasse: values.motDePasse,
  };
  return utilisateur;
};

export const getIdsAdb = (utilisateurConnecte: Utilisateur) => {
  const getDetailAdbs: UtilisateurDetailAdbProfilSites[] | undefined =
    utilisateurConnecte && utilisateurConnecte.detailAdbProfilSites;
  const listIdAdbs = getDetailAdbs && getDetailAdbs.map((adb) => adb.refAdb);
  return listIdAdbs || [];
};

export const getProfilsAdb = (
  adbsUtilisateurs: UtilisateurDetailAdbProfilSites[]
) => {
  return (
    adbsUtilisateurs &&
    adbsUtilisateurs.map((adb, i) =>
      i === 0 ? adb.profil : " / " + adb.profil
    )
  );
};
export const getInfoTableau = (
  results: Utilisateur[],
  postes?: FonctionPoste[],
  isBesse?: boolean
) => {
  return results.map((result) => ({
    ...result,
    numAdherent:
      result.detailAdbProfilSites &&
      result.detailAdbProfilSites.map((adb, i) =>
        i === 0 ? adb.nomAdb : " / " + adb.nomAdb
      ),
    fonction: postes
      ? postes.find((fonction) => fonction.identifiant === result.fonction)
      : "-",
    profil: isBesse
      ? result.nomProfilBesse
      : result.detailAdbProfilSites &&
        result.detailAdbProfilSites.map((adb, i) =>
          i === 0 ? adb.nomProfil : " / " + adb.nomProfil
        ),
  }));
};
